import { Injectable } from '@angular/core';
import { CartItemModel } from '@libs/shop/models';

export interface EsaInfo {
  esaCount: number;
  missingEsaItems: number;
  isInvalidEsaCount: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class EsaService {
  public getEsaInfo(cartItems: CartItemModel[] | undefined): EsaInfo {
    const esaCount: number = cartItems ? cartItems
      .filter((item) => item.productData.isEsa)
      .reduce((acc, esaItem) => acc + Number(esaItem.quantity), 0) : 0;
    const missingEsaItems: number = this.getMissingEsaItems(esaCount);
    const isInvalidEsaCount: boolean = esaCount > 0 && missingEsaItems > 0;

    return {
      esaCount,
      missingEsaItems,
      isInvalidEsaCount,
    };
  }

  private getMissingEsaItems(esaCount: number): number {
    if (esaCount < 6) {
      return 6 - esaCount;
    }

    const remainder: number = esaCount % 3;

    return remainder > 0 ? 3 - remainder : 0;
  }
}
